<template>
  <v-container class="mt-8">
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="mb-0 pb-0 pt-0 mt-0"
        v-for="(singleTable, index) in FOODS"
        :key="index"
      >
        <!-- Same structure as lunchTables: one table, <tr> rows inside a single
             <tbody>. This was a <table> nested in v-simple-table's own <table>,
             with <th>/<td> as direct children of one <tbody> per restaurant and
             no <tr>. Vue builds that DOM directly, so the parser never inserts
             the missing rows and some engines rendered only the first entry. -->
        <table class="other-table mb-4">
          <thead>
            <tr class="lunch-table-header">
              <th colspan="2">
                {{ singleTable.HEADER }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(restaurant, restaurantIndex) in restaurantsOf(singleTable)"
              :key="restaurantIndex"
            >
              <th class="w-33">
                <a :href="restaurant.url">
                  {{ restaurant.name }}
                </a>
              </th>
              <td class="w-66">
                {{ restaurant.genre }}
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: "App",
  data() {
    return {
      FOODS: [],
    };
  },
  methods: {
    restaurantsOf(table) {
      return Array.isArray(table.Restaurants) ? table.Restaurants : [];
    },
    getData() {
      let path = "/others.json";
      fetch(path)
        .then((res) => res.json())
        .then((out) => {
          this.FOODS = Array.isArray(out) ? out : [];
        })
        .catch((err) => {
          // Rethrowing only produced an unhandled rejection; the list simply
          // stays empty, which is the same thing the reader would have seen.
          console.error("Other restaurants load failed:", path, err);
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>



<style scoped>
a {
  color: #0067a7 !important;
  text-decoration: none;
}
a:hover {
  color: #0c0c0c;
  text-decoration: underline;
}

.lunch-table-header {
  text-align: center;
  background-color: #e6e6e6;
}

thead,
th {
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #e9ecef;
  border: 1px solid #e9ecef;
  padding: 4px;
}

td {
  border: 1px solid #e9ecef;
  padding-left: 10px;
}

.other-table {
  width: 100%;
  max-width: 100%;
  background-color: transparent;
  border-collapse: collapse;
  border: 1px solid #e9ecef;
  display: table;
  white-space: normal;
  line-height: normal;
  font-weight: normal;
  font-size: medium;
  font-style: normal;
  text-align: start;
  border-spacing: 2px;
  font-variant: normal;
}

.w-66 {
  width: 66% !important;
}
.w-33 {
  width: 33% !important;
}
</style>
